import { render, staticRenderFns } from "./AlarmDetector.vue?vue&type=template&id=7f8e9a95&scoped=true"
import script from "./AlarmDetector.vue?vue&type=script&lang=js"
export * from "./AlarmDetector.vue?vue&type=script&lang=js"
import style0 from "./AlarmDetector.vue?vue&type=style&index=0&id=7f8e9a95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8e9a95",
  null
  
)

export default component.exports